/**
 * Build a CSS `image-set()` value for a background-image, ordered from most to
 * least optimized so the browser stops at the first format it supports.
 *
 * image-set() is Baseline (widely available since 2023), so it is safe to use
 * without a separate cascade fallback here. The PNG/JPEG entry inside the set
 * remains the universal fallback for engines that support image-set().
 *
 * Usage (URLs come from Parcel `url:` imports):
 *   style={{ backgroundImage: bgImageSet({ avif, webp, fallback }) }}
 */
export function bgImageSet({ avif, webp, fallback }) {
  const entries = [];
  if (avif) entries.push(`url("${avif}") type("image/avif")`);
  if (webp) entries.push(`url("${webp}") type("image/webp")`);
  if (fallback) {
    const type = fallback.toLowerCase().includes('.png') ? 'image/png' : 'image/jpeg';
    entries.push(`url("${fallback}") type("${type}")`);
  }
  return `image-set(${entries.join(', ')})`;
}
